import script from "./blfkl.vue?vue&type=script&setup=true&lang=js"
export * from "./blfkl.vue?vue&type=script&setup=true&lang=js"

import "./blfkl.vue?vue&type=style&index=0&id=552c83d5&lang=scss&scoped=true"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-552c83d5"]])

export default __exports__